import { createApiResponseSchema, type IAPI } from '../../apiResponse';
import type { IValidatedResponse } from '../../httpClient';
import { deleteRequest } from '../../httpClient';

const schema = createApiResponseSchema();

export async function resetLeaderboardEntryApi(userId: string): Promise<IValidatedResponse<IAPI>> {
  return deleteRequest<IAPI>({
    path: `/sys/leaderboard/${userId}`,
    schema,
  });
}
